export default __webpack_public_path__ + "static/media/Snd_C1.ac97b3cb.mp3";